export default "__VITE_ASSET__CEiwB$cq__"